<!-- H5流程框架 -->
<template lang="pug">
.summary(v-if="uuid")
  van-nav-bar(left-text='返回', :title='flowTitle', left-arrow, @click-left='clickLeft')
  prjSelectH5(:uuid="uuid" v-if="hasSelctor")
  .content
    addApproval(ref="addApproval", v-if="flowType === 1 || flowType === 4|| flowType === 5" :uuid="uuid")
    flowDetail(ref="flowDetail", v-else, :uuid="uuid" @closeDialog="closeDialog")
  .footer
    .intervene(@click="interveneShow = true" v-if="hasIntervene")
      van-image(:src="interveneImage" width="20" height="25")
      span 流程干预
    .buttons
      van-button( type="info", round, plain v-if="flowType===1||flowType===4" @click="temporaryStorage('h5')") 暂存
      van-button( type="info", round v-if="withdrawBoolean" @click="withdraw('h5')") 撤回
      van-button( type="info", round v-if="flowAgainBoolean" @click="relaunch('h5')") 重新发起
      van-button( type="info", round v-if="flowType===1||flowType===4" @click="submitProcess('h5')") 提交并发起流程
      van-button( type="info", round v-if="flowType===5" @click="flowAgainSure('h5')") 流程再发起
  //- 流程干预弹框
  van-action-sheet(v-model:show="interveneShow" :actions="actions"  cancel-text="取消" close-on-click-action @select='handleCommand')
</template>

<script>
import { mapState } from "vuex";
import { appBackWindow } from "@/CommonDP/pages/appView/utils/index.js";
import { deleteApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import { setFlowData } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { summaryMixins } from "@/CommonDP/components/processComponents/flowNew/mixins.js";
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import prjSelectH5 from "@/CommonDP/components/processComponents/components/prjSelectH5.vue";
import addApproval from "./addApproval.vue";
import flowDetail from "./flowDetail.vue";

export default {
  components: { addApproval, flowDetail, prjSelectH5 },
  mixins: [asyncMixin, summaryMixins],
  data() {
    return {
      interveneShow: false, // 干预弹框
      uuid: "",
      actions: [
        { name: "驳回", command: "rejectAdmin" },
        { name: "终止", command: "terminationAdmin" },
        { name: "通过节点", command: "passNodeAdmin" },
        { name: "通过流程", command: "passAdmin" }
      ]
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    interveneImage() {
      return require("../image/ganyu.png");
    },
    // 当前节点
    activeNode() {
      let activeNode = {};
      const currentIndex = this.nodeList.findIndex((e) => e.nodeStatus === "2");
      if (currentIndex) activeNode = this.nodeList[currentIndex] || {};
      return activeNode;
    },
    // 是否需要审批
    accepApprove() {
      const { assigneeList } = this.activeNode || {};
      return nodeStatus === "2" && assigneeList.some((e) => e.result === "2" && e.userId === this.userInfo.userId) && this.flowType === 2;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const data = this.$route.query || {};
      this.uuid = await setFlowData(data);
    },
    clickLeft() {
      appBackWindow();
    },
    closeDialog() {
      this.resolve();
      this.handleClose();
    },
    handleClose() {
      deleteApprove(this.uuid);
      setTimeout(() => {
        this.$router.back();
      }, 1000);
    },
    handleCommand(item) {
      const { command } = item || {};
      switch (command) {
        case "rejectAdmin":
          this.rejectAdmin("h5");
          break;
        case "terminationAdmin":
          this.terminationAdmin("h5");
          break;
        case "passNodeAdmin":
          this.passNodeAdmin("h5");
          break;
        case "passAdmin":
          this.passAdmin("h5");
          break;
        default:
          break;
      }
    },

    // 流程详情-基本数据
    detailBasicData() {
      return this.$refs.flowDetail?.getBasicData() || {};
    }
  }
};
</script>

<style lang="scss" scoped>
.summary {
  height: 100%;
  width: 100%;
  background: #f5f6fa;
  display: flex;
  flex-direction: column;
  .content {
    height: 1px;
    flex: 1;
    overflow-y: auto;
  }
}
.footer {
  width: 100%;
  margin-top: 10px;
  padding: 10px 0;
  background-color: #fff;
  display: flex;
  align-items: center;

  .intervene {
    width: 90px;
    margin-left: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    span{
      color: #1989fa;
      font-weight: 700;
      font-size: 14px;
    }
  }
  .buttons {
    width: 1px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .van-button {
      margin: 0 10px;
      min-width: 80px;
      height: 36px;
    }
  }
}

::v-deep .van-action-sheet__item {
  border-top: 1px solid#E5E8F1;
  span {
    font-size: 16px;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>

<style>
.el-message-box {
  max-width: 90vw;
}
</style>
